import React from "react";

import PageLayout from "siteLayouts/Page";

import { ContainerMaxWidth, Panel, PanelSection } from "siteComponentsLibrary/Layout";
import { HyperlinkRoute } from "siteComponentsLibrary/Buttons";
import { EmailLink } from "siteComponentsLibrary/Display";

const assets = require("siteAssets/pageManager").default("terms-of-use");

const TermsPanelSection = (props) => {
	const { itemNumber, itemContent, subItems, itemDepth = 1 } = props;

	return (
		<PanelSection heading={`${itemNumber} ${itemContent}`}>
			<TermsContent
				itemNumber={itemNumber}
				data={subItems}
			/>
		</PanelSection>
	);
}

const TermsContent = (props) => {
	const { data, itemNumber, itemDepth = 1 } = props;

	if (!data)
		return null;

	return (
		<>
			{data.map((item, i) => {
				return (
					<TermsItem
						itemDepth={itemDepth}
						itemNumber={item.itemNumber ? item.itemNumber : `${itemNumber}${i + 1}`}
						itemContent={item.content}
						subItems={item.subItems}
						textAfterItems={item.textAfterItems}
					/>
				)
			})}
		</>
	);

}

const TermsItem = (props) => {

	const { itemDepth = 1, itemNumber, itemContent, subItems, textAfterItems } = props;

	return (
		<>
			<div className={`d-flex term-${itemDepth}`}>
				<span className="d-inline-block pe-2 me-3 term-number align-self-stretch">{itemNumber}</span>
				<div className="d-inline">
					{itemContent}
				</div>
			</div>
			{subItems && (
				subItems.map((item, i) => {
					return (
						<TermsItem
							itemDepth={itemDepth + 1}
							itemNumber={item.itemNumber ? item.itemNumber : `${itemNumber}${i + 1}`}
							itemContent={item.content}
							subItems={item.subItems}
							textAfterItems={item.textAfterItems}
						/>
					);
				})
			)}
			{textAfterItems && (
				<TermsItem
					itemDepth={itemDepth}
					itemNumber="&nbsp;"
					itemContent={textAfterItems}
				/>
			)}
		</>
	);

}

const TermsOfUse = (props) => {
	return (
		<PageLayout
			pageTitle={assets.pageTitle}
			headingText={assets.headingText}
		>
			<ContainerMaxWidth>
				<Panel header={assets.panelHeader}>
					<TermsPanelSection
						itemNumber="1."
						itemContent="Introduction"
						subItems={[
							{ content: "This disclaimer shall govern your use of our website." },
							{ content: "By using our website, you accept this disclaimer in full; accordingly, if you disagree with this disclaimer or any part of this disclaimer, you must not use our website." },
							{
								content: (
									<>
										Our website uses cookies; by using our website or
										agreeing to this disclaimer, you consent to our use of cookies in
										accordance with the terms of our{" "}
										<HyperlinkRoute route="/cookie-policy" label="cookie policy" className="btn btn-link btn-link-inline" />.
									</>
								)
							},
							{
								content: <>Freedom Retail Ltd is part of the One Sure Group. Freedom Retail Ltd is an appointed representative of One Sure Insurance Ltd, which is authorised and regulated by the Financial Conduct Authority (FRN: 447730).</>
							}
						]}
					/>

					<TermsPanelSection
						itemNumber="2."
						itemContent="Copyright notice"
						subItems={[
							{ content: "Copyright (C) 2025 Freedom Retail Ltd, part of the One Sure Group." },
							{
								content: "Subject to the express provisions of this disclaimer:",
								subItems: [
									{ itemNumber: "(a)", content: "we, together with our licensors, own and control all the copyright and other intellectual property rights in our website and the material on our website; and" },
									{ itemNumber: "(b)", content: "all the copyright and other intellectual property rights in our website and the material on our website are reserved." }
								]
							},
						]}
					/>

					<TermsPanelSection
						itemNumber="3."
						itemContent="Licence to use website"
						subItems={[
							{
								content: "You may:",
								subItems: [
									{ itemNumber: "(a)", content: "view pages from our website in a web browser;" },
									{ itemNumber: "(b)", content: "download pages from our website for caching in a web browser; and" },
									{ itemNumber: "(c)", content: "print pages from our website," }
								],
								textAfterItems: "subject to the other provisions of this disclaimer."
							},
							{ content: "Except as expressly permitted by Section 3.1 or the other provisions of this disclaimer, you must not download any material from our website or save any such material to your computer." },
							{ content: "You may only use our website for your own personal and business purposes, and you must not use our website for any other purposes." },
							{
								content: "Unless you own or control the relevant rights in the material, you must not:",
								subItems: [
									{ itemNumber: "(a)", content: "republish material from our website (including republication on another website);" },
									{ itemNumber: "(b)", content: "sell, rent or sub-license material from our website;" },
									{ itemNumber: "(c)", content: "show any material from our website in public;" },
									{ itemNumber: "(d)", content: "exploit material from our website for a commercial purpose; or" },
									{ itemNumber: "(e)", content: "redistribute material from our website." }
								],
							},
							{ content: "We reserve the right to restrict access to areas of our website, or indeed our whole website, at our discretion; you must not circumvent or bypass, or attempt to circumvent or bypass, any access restriction measures on our website." }
						]}
					/>

					<TermsPanelSection
						itemNumber="4."
						itemContent="Acceptable use"
						subItems={[
							{
								content: "You must not:",
								subItems: [
									{ itemNumber: "(a)", content: "use our website in any way or take any action that causes, or may cause, damage to the website or impairment of the performance, availability or accessibility of the website;" },
									{ itemNumber: "(b)", content: "use our website in any way that is unlawful, illegal, fraudulent or harmful, or in connection with any unlawful, illegal, fraudulent or harmful purpose or activity;" },
									{ itemNumber: "(c)", content: "use our website to copy, store, host, transmit, send, use, publish or distribute any material which consists of (or is linked to) any spyware, computer virus, Trojan horse, worm, keystroke logger, rootkit or other malicious computer software;" },
									{ itemNumber: "(d)", content: "conduct any systematic or automated data collection activities (including without limitation scraping, data mining, data extraction and data harvesting) on or in relation to our website without our express written consent;" },
									{ itemNumber: "(e)", content: "access or otherwise interact with our website using any robot, spider or other automated means, except for the purpose of search engine indexing;" },
									{ itemNumber: "(f)", content: "violate the directives set out in the robots.txt file for our website; or" },
									{ itemNumber: "(g)", content: "use data collected from our website for any direct marketing activity (including without limitation email marketing, SMS marketing, telemarketing and direct mailing)." },
								],
							},
							{ content: "You must not use data collected from our website to contact individuals, companies or other persons or entities." },
							{ content: "You must ensure that all the information you supply to us through our website, or in relation to our website, is true, accurate, current, complete and non-misleading." },
						]}
					/>

					<TermsPanelSection
						itemNumber="5."
						itemContent="Limited warranties"
						subItems={[
							{
								content: "We do not warrant or represent:",
								subItems: [
									{ itemNumber: "(a)", content: "the completeness or accuracy of the information published on our website;" },
									{ itemNumber: "(b)", content: "that the material on the website is up to date; or" },
									{ itemNumber: "(c)", content: "that the website or any service on the website will remain available." },
								],
							},
							{ content: "We reserve the right to discontinue or alter any or all of our website services, and to stop publishing our website, at any time in our sole discretion without notice or explanation; and save to the extent expressly provided otherwise in this disclaimer, you will not be entitled to any compensation or other payment upon the discontinuance or alteration of any website services, or if we stop publishing the website." },
							{ content: "To the maximum extent permitted by applicable law and subject to Section 6.1, we exclude all representations and warranties relating to the subject matter of this disclaimer, our website and the use of our website." },
						]}
					/>

					<TermsPanelSection
						itemNumber="6."
						itemContent="Limitations and exclusions of liability"
						subItems={[
							{
								content: "Nothing in this disclaimer will:",
								subItems: [
									{ itemNumber: "(a)", content: "limit or exclude any liability for death or personal injury resulting from negligence;" },
									{ itemNumber: "(b)", content: "limit or exclude any liability for fraud or fraudulent misrepresentation;" },
									{ itemNumber: "(c)", content: "limit any liabilities in any way that is not permitted under applicable law; or" },
									{ itemNumber: "(d)", content: "exclude any liabilities that may not be excluded under applicable law." },
								],
							},
							{
								content: "The limitations and exclusions of liability set out in this Section 6 and elsewhere in this disclaimer:",
								subItems: [
									{ itemNumber: "(a)", content: "are subject to Section 6.1; and" },
									{ itemNumber: "(b)", content: "govern all liabilities arising under this disclaimer or relating to the subject matter of this disclaimer, including liabilities arising in contract, in tort (including negligence) and for breach of statutory duty, except to the extent expressly provided otherwise in this disclaimer." },
								],
							},
							{ content: "To the extent that our website and the information and services on our website are provided free of charge, we will not be liable for any loss or damage of any nature." },
							{ content: "We will not be liable to you in respect of any losses arising out of any event or events beyond our reasonable control." },
							{ content: "We will not be liable to you in respect of any business losses, including (without limitation) loss of or damage to profits, income, revenue, use, production, anticipated savings, business, contracts, commercial opportunities or goodwill." },
							{ content: "We will not be liable to you in respect of any loss or corruption of any data, database or software." },
							{ content: "We will not be liable to you in respect of any special, indirect or consequential loss or damage." },
							{ content: "You accept that we have an interest in limiting the personal liability of our officers and employees and, having regard to that interest, you acknowledge that we are a limited liability entity; you agree that you will not bring any claim personally against our officers or employees in respect of any losses you suffer in connection with the website or this disclaimer (this will not, of course, limit or exclude the liability of the limited liability entity itself for the acts and omissions of our officers and employees)." },
						]}
					/>

					<TermsPanelSection
						itemNumber="7."
						itemContent="Variation"
						subItems={[
							{ content: "We may revise this disclaimer from time to time." },
							{ content: "The revised disclaimer shall apply to the use of our website from the time of publication of the revised disclaimer on the website." },
						]}
					/>

					<TermsPanelSection
						itemNumber="8."
						itemContent="Severability"
						subItems={[
							{ content: "If a provision of this disclaimer is determined by any court or other competent authority to be unlawful and/or unenforceable, the other provisions will continue in effect." },
							{ content: "If any unlawful and/or unenforceable provision of this disclaimer would be lawful or enforceable if part of it were deleted, that part will be deemed to be deleted, and the rest of the provision will continue in effect." },
						]}
					/>

					<TermsPanelSection
						itemNumber="9."
						itemContent="Law and jurisdiction"
						subItems={[
							{ content: "This disclaimer shall be governed by and construed in accordance with English law." },
							{ content: "Any disputes relating to this disclaimer shall be subject to the exclusive jurisdiction of the courts of England." },
						]}
					/>

					<TermsPanelSection
						itemNumber="10."
						itemContent="Statutory and regulatory disclosures"
						subItems={[
							{ content: "Freedom Retail Ltd is registered in England and Wales and our registration number is 16372250." },
							{ content: "Freedom Retail Ltd is an appointed representative of One Sure Insurance Limited, which is authorised and regulated by the Financial Conduct Authority (FCA), FRN 447730. One Sure Insurance Ltd is registered in England & Wales under company number 05649077" },
						]}
					/>

					<TermsPanelSection
						itemNumber="11."
						itemContent="Our details"
						subItems={[
							{ content: "This website is owned and operated by Freedom Retail Ltd." },
							{ content: "Our registered address at Spitfire House, 142-154 Congleton Road, Talke, Stoke-on-Trent, Staffordshire, England, ST7 1LX." },
							{
								content: "You can contact us:",
								subItems: [
									{ itemNumber: "(a)", content: "by post, using the postal address given above;" },
									{ itemNumber: "(b)", content: "by telephone, on the contact number published on our website from the times stated on our contact us page or" },
									{
										itemNumber: "(c)",
										content: (
											<EmailLink emailAddress={require("config").default.emailAddresses.customerService} altLabel="by email" />
										)
									},
								],
							},
						]}
					/>
				</Panel>
			</ContainerMaxWidth>

		</PageLayout>
	);
};

export default TermsOfUse;
